import { render } from "./OuterContentsInput.vue?vue&type=template&id=514ed948&scoped=true&ts=true"
import script from "./OuterContentsInput.vue?vue&type=script&lang=ts"
export * from "./OuterContentsInput.vue?vue&type=script&lang=ts"

import "./OuterContentsInput.vue?vue&type=style&index=0&id=514ed948&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514ed948"]])

export default __exports__